export const mockedGroupsResponse = {
  data: [
    {
      id: 1,
      name: 'interns',
      include_in_reports: false,
      managers: [
        { id: 1, name: 'John Doe' },
        { id: 2, name: 'Jane Smith' },
      ],
    },
    {
      id: 2,
      name: 'Management',
      include_in_reports: true,
      managers: [{ id: 3, name: 'Bob Johnson' }],
    },
    {
      id: 3,
      name: 'Super Secret Agent 99',
      include_in_reports: false,
      managers: [],
    },
  ],
};
